import { render, staticRenderFns } from "./CardEmpresaProdutorFazenda.vue?vue&type=template&id=3d25c082"
import script from "./CardEmpresaProdutorFazenda.vue?vue&type=script&lang=js"
export * from "./CardEmpresaProdutorFazenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports